


import React from "react";

const Services = () => {
  const blogItems = [
    {
      img: "/images/keyword/5.jpg",
      href: "/pune-to-mumbai-cabs",
      title: "Pune to Mumbai Cabs",
      text: "Experience a comfortable and hassle-free journey from Pune to Mumbai with Platinum24 Cabs. Our well-maintained fleet and professional drivers ensure timely pickups and safe travel, whether it’s for business or leisure.",
      readMore: "/pune-to-mumbai-cabs",
    },
    {
      img: "/images/keyword/6.jpg",
      href: "/pune-to-nashik-cabs",
      title: "Pune to Nashik Cabs",
      text: "Travel from Pune to Nashik in style with Platinum24 Cabs. Whether for a weekend getaway or business meetings, our reliable service guarantees a smooth and comfortable ride.",
      readMore: "/pune-to-nashik-cabs",
    },
    {
      img: "/images/keyword/8.jpg",
      href: "/pune-to-lonavala-cabs",
      title: "Pune to Lonavala Cabs",
      text: "Planning a trip to the scenic hill station of Lonavala? Choose Platinum24 Cabs for a comfortable and scenic drive with expert drivers who know the best routes.",
      readMore: "/pune-to-lonavala-cabs",
    },
    {
      img: "/images/keyword/13.jpg",
      href: "/ashtavinayak-darshan-cab",
      title: "Ashtavinayak Darshan Cab",
      text: "Make your Ashtavinayak pilgrimage easier with Platinum24 Cabs. We provide convenient, safe, and punctual transportation to all the temples from Pune.",
      readMore: "/ashtavinayak-darshan-cab",
    },
    {
      img: "/images/keyword/14.jpg",
      href: "/pune-to-goa-cabs",
      title: "Pune to Goa Cabs",
      text: "Looking to escape to the beaches of Goa? Platinum24 Cabs offers a safe and reliable taxi service with comfortable vehicles for a hassle-free journey.",
      readMore: "/pune-to-goa-cabs",
    },
    {
      img: "/images/keyword/25.jpg",
      href: "/pune-to-ganpatipule-taxi",
      title: "Pune to Ganpatipule Taxi",
      text: "For your spiritual trip to Ganpatipule, trust Platinum24 Cabs to provide timely and comfortable taxi services with knowledgeable drivers.",
      readMore: "/pune-to-ganpatipule-taxi",
    },
  ];

  return (
    <>
      <div
        className="breadcumb-wrapper"
        // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Services</h1>
          </div>
        </div>
      </div>

      <div className="vs-blog-wrapper space-top space-extra-botom">
        <div className="container">
          <div className="row gx-30">
            <div className="col-lg-12">
              <div className="row">
                {blogItems.map((item, idx) => (
                  <div
                    key={idx}
                    className="col-xl-4 col-md-6 col-sm-12 col-12"
                  >
                    <div className="service-card">
                   

                      {/* Service Image */}
                      <div className="service-img">
                        <img src={item.img} alt={item.title} />
                        <div className="service-overlay">
                          <a className="service-btn" href={item.readMore}>
                            Read More <i className="fal fa-arrow-right"></i>
                          </a>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="service-content">
                        <h2 className="service-title">
                          <a href={item.href}>{item.title}</a>
                        </h2>
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
